import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-newsletter">
          <div className="newsletter-content">
            <h3 className="newsletter-title">Stay Informed</h3>
            <p className="newsletter-subtitle">
              Get exclusive insights and market updates delivered to your inbox
            </p>
            <div className="newsletter-form">
              <input 
                type="email" 
                placeholder="Enter your email address" 
                className="newsletter-input"
              />
              <button className="newsletter-btn">Subscribe</button>
            </div>
          </div>
        </div>

        <div className="footer-main">
          <div className="footer-brand">
            <div className="brand-logo">
              <img 
                src="/logo_verticle.png" 
                alt="Rayad Group" 
                className="footer-logo-img"
              />
            </div>
            <p className="brand-tagline">
              Backing the bold to foster innovation since 1994
            </p>
          </div>

          <div className="footer-grid">
            <div className="footer-column">
              <h4 className="column-title">Services</h4>
              <div className="service-links">
                <Link to="/portfolio/software-development" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Software Development</span>
                </Link>
                <Link to="/portfolio/cybersecurity" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Cyber Security</span>
                </Link>
                <Link to="/portfolio/blockchain-seed-investment" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Blockchain & Crypto</span>
                </Link>
                <Link to="/portfolio/intrusion-detection" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Electronic Intrusion Detection</span>
                </Link>
                <Link to="/portfolio/education" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Techucation</span>
                </Link>
                <Link to="/portfolio/biotech" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Biotech & Longevity</span>
                </Link>
                <Link to="/portfolio/immigration" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Immigration Services</span>
                </Link>
                <Link to="/portfolio/corporate-services" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Corporate Services</span>
                </Link>
              </div>
            </div>

            <div className="footer-column">
              <h4 className="column-title">Company</h4>
              <div className="service-links">
                <Link to="/" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Home</span>
                </Link>
                <Link to="/portfolio" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Portfolio</span>
                </Link>
                <Link to="/about" className="service-link">
                  <span className="link-icon">→</span>
                  <span>About</span>
                </Link>
                <Link to="/contact" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Contact</span>
                </Link>
              </div>
            </div>

            <div className="footer-column">
              <h4 className="column-title">Media & More</h4>
              <div className="service-links">
                <Link to="/media/news" className="service-link">
                  <span className="link-icon">→</span>
                  <span>News Articles</span>
                </Link>
                <Link to="/media/videos" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Videos</span>
                </Link>
                <Link to="/global-media-coverage" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Global Media Coverage</span>
                </Link>
                <Link to="/portfolio/business-financial-advisory" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Business Advisory</span>
                </Link>
                <Link to="/portfolio/art" className="service-link">
                  <span className="link-icon">→</span>
                  <span>Emirati & Contemporary Art</span>
                </Link>
              </div>
              <div className="contact-details" style={{marginTop: '30px'}}>
                <div className="contact-item">
                  <span className="contact-label">General</span>
                  <span className="contact-value">info@rayadgroup.com</span>
                </div>
                <div className="contact-item">
                  <span className="contact-label">Investors</span>
                  <span className="contact-value">investor-relations@rayadgroup.com</span>
                </div>
                <div className="contact-item">
                  <span className="contact-label">Media</span>
                  <span className="contact-value">media@rayadgroup.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-stats">
            <div className="footer-stat-item">
              <span className="footer-stat-number">Pioneering </span>
              <span className="footer-stat-label">Global Solutions</span>
            </div>
            <div className="footer-stat-item">
              <span className="footer-stat-number">30+</span>
              <span className="footer-stat-label">Years Experience</span>
            </div>
            <div className="footer-stat-item">
              <span className="footer-stat-number">100%</span>
              <span className="footer-stat-label">Client Satisfaction</span>
            </div>
          </div>
          
          <div className="footer-legal">
            <p>&copy; 2025 Rayad Group. All rights reserved.</p>
            <div className="legal-menu">
              <span>Privacy Policy</span>
              <span>Terms of Use</span>
              <span>Disclosures</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;